export default "__VITE_ASSET__BQXZPEhq__"